import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8456a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "setting-panel-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "setting-panel service-settings"
}
const _hoisted_3 = {
  key: 0,
  class: "panel-section"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, " 开关机 ", -1))
const _hoisted_5 = { class: "section-content" }
const _hoisted_6 = {
  key: 0,
  class: "setting-box autopower-setting"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "来电自动开机")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "定时开关机")
], -1))
const _hoisted_9 = {
  key: 2,
  class: "setting-box alarm-setting border-radius-bottom"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "开机时间", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "关机时间", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "重复", -1))
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-caret-down" }, null, -1))
const _hoisted_17 = { class: "popover-container alarm-setting" }
const _hoisted_18 = { class: "popover-selector" }
const _hoisted_19 = ["onClick", "checked"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "panel-section"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, " 设备灯 ", -1))
const _hoisted_23 = { class: "section-content" }
const _hoisted_24 = { class: "setting-box led-setting" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "LED灯")
], -1))
const _hoisted_26 = {
  key: 2,
  class: "panel-section"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, " 屏幕 ", -1))
const _hoisted_28 = { class: "section-content backer-content" }
const _hoisted_29 = { class: "setting-box lcd-setting" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "自动休眠")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-caret-down" }, null, -1))
const _hoisted_32 = { class: "popover-container lcd-setting" }
const _hoisted_33 = { class: "popover-selector" }
const _hoisted_34 = ["onClick", "checked"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_36 = {
  key: 3,
  class: "panel-section"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, " 风扇 ", -1))
const _hoisted_38 = { class: "section-content backer-content" }
const _hoisted_39 = { class: "setting-box lcd-setting" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "风扇模式")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-caret-down" }, null, -1))
const _hoisted_42 = { class: "popover-container" }
const _hoisted_43 = { class: "popover-selector" }
const _hoisted_44 = ["onClick", "checked"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))

import { watch, ref, reactive, onMounted } from 'vue'
import debounce from 'lodash/debounce'
import XPopover from '@remote/components/Popover.vue'
import Switch from '@remote/components/switchbox/Switch.vue'
import Loading from '@remote/components/Loading.vue'
import { checkDeviceState } from '@remote/store/utils'
import { toast } from '@remote/utils/dialog'
import { getXOSDeviceStatus, setXOSDeviceInfo } from '@remote/api/adapter/xos-mqtt'


export default /*#__PURE__*/_defineComponent({
  props: {
    isActive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isActive:boolean
}

const lcdModesValue2LabelMaps = {
  '-1': '永不休眠',
  '5': '5分钟',
  '10': '10分钟',
  '30': '30分钟',
  '60': '60分钟',
}

const alarmAllModeValue = '1,2,3,4,5,6,7'
const alarmModeDisplayArray = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
const alarmModes = [
  {
    value: 'all',
    label: '每天',
  },
  {
    value: '7',
    label: '周日',
  },
  {
    value: '1',
    label: '周一',
  },
  {
    value: '2',
    label: '周二',
  },
  {
    value: '3',
    label: '周三',
  },
  {
    value: '4',
    label: '周四',
  },
  {
    value: '5',
    label: '周五',
  },
  {
    value: '6',
    label: '周六',
  },
]


const lcdModes = [
  {
    value: -1,
    label: '永不休眠',
  },
  {
    value: 5,
    label: '5分钟',
  },
  {
    value: 10,
    label: '10分钟',
  },
  {
    value: 30,
    label: '30分钟',
  },
  {
    value: 60,
    label: '60分钟',
  },
]

const fanModes = [
  {
    value: 1,
    label: '智能模式',
    text: '硬件根据当前运行温度，智能调节风扇转数',
  },
  {
    value: 2,
    label: '静音模式',
    text: '风扇以低转数运行，声音较小',
  },
  {
    value: 3,
    label: '全速模式',
    text: '风扇全速运行，声音较大',
  },
]



const isLoading = ref(true)

const overStyle = reactive({
  bottom: 'auto',
  right: 'auto',
  left: '680px',
  zIndex: 99,
  top: '462px',
  padding: 0,
})

const alarmModeSelectorVisible = ref(false)
const lcdModeSelectorVisible = ref(false)
const fanModeSelectorVisible = ref(false)

const deviceSettingsVisible = reactive({
  auto_power: false,
  alarm: false,
  led: false,
  lcd: false,
  fan: false,
})

const deviceSettings = reactive({
  auto_power: false,
  alarm: {
    enable: false,
    mode: '1,2,3,4,5,6,7',
    onTimeH: '08',
    onTimeM: '00',
    offTimeH: '23',
    offTimeM: '00',
    display: '每天',
  },
  led: false,
  lcd: 5,
  fan: 2,
})

const updateDeviceAlarmConfig = debounce(() => {
  if (checkDeviceState()) return
  const onTime = `${deviceSettings.alarm.onTimeH}:${deviceSettings.alarm.onTimeM}`
  const offTime = `${deviceSettings.alarm.offTimeH}:${deviceSettings.alarm.offTimeM}`
  if (onTime === offTime) return toast('开机时间和关机时间不能相同')
  setXOSDeviceInfo({
    biz: 'alarm',
    enable: 1,
    ext: {
      on_time: onTime,
      off_time: offTime,
      repeat: deviceSettings.alarm.mode,
    },
  }).catch(toast)
}, 1000)

const handleOnInputAlarmTime = (e, key: 'onTimeH'|'onTimeM'|'offTimeH'|'offTimeM', max: number) => {
  console.log('handleOnInputAlarmTime', key, max, e.target.value)
  const value = Math.min(max, parseInt(e.target.value))
  deviceSettings.alarm[key] = value > 10 ? String(value) : `0${value}`
  updateDeviceAlarmConfig()
}

const handleSetAlarmMode = (mode: string) => {
  const currentMode = deviceSettings.alarm.mode
  if (mode === 'all') {
    deviceSettings.alarm.mode = currentMode === alarmAllModeValue ? '' : alarmAllModeValue
    if (deviceSettings.alarm.mode === alarmAllModeValue) deviceSettings.alarm.display = '每天'
  } else {
    const currentModeArray = currentMode ? currentMode.split(',') : []
    const index = currentModeArray.indexOf(mode)
    if(index < 0) {
      currentModeArray.push(mode)
      currentModeArray.sort()
    } else {
      currentModeArray.splice(index, 1)
    }
    const nextMode = currentModeArray.join(',')
    deviceSettings.alarm.mode = nextMode
    deviceSettings.alarm.display = nextMode === alarmAllModeValue ? '每天': currentModeArray.map(item => alarmModeDisplayArray[+item - 1]).join('/')
  }
  updateDeviceAlarmConfig()
}

const handleSetLcdMode = (mode: number) => {
  if (checkDeviceState()) return
  deviceSettings.lcd = mode
  lcdModeSelectorVisible.value = false
  setXOSDeviceInfo({
    biz: 'lcd',
    ext: {
      mode,
    },
  }).catch(toast)
}

const handleSetFanMode = (mode: number) => {
  if (checkDeviceState()) return
  deviceSettings.fan = mode
  fanModeSelectorVisible.value = false
  setXOSDeviceInfo({
    biz: 'fan',
    ext: {
      mode,
    },
  }).catch(toast)
}

function handleOnToggleSetting (biz: 'auto_power'|'alarm'|'led') {
  if (checkDeviceState()) return
  let enable
  let ext
  if (biz === 'alarm') {
    enable = !deviceSettings.alarm.enable
    deviceSettings.alarm.enable = enable
    ext = {
      on_time: `${deviceSettings.alarm.onTimeH}:${deviceSettings.alarm.onTimeM}`,
      off_time: `${deviceSettings.alarm.offTimeH}:${deviceSettings.alarm.offTimeM}`,
      repeat: deviceSettings.alarm.mode,
    }
  } else {
    enable = !deviceSettings[biz]
    deviceSettings[biz] = enable
  }
  setXOSDeviceInfo({
    biz,
    enable: enable ? 1 : -1,
    ext,
  }).catch(toast)
}

function hideAlarmModeSelector () {
  alarmModeSelectorVisible.value = false
  if (!deviceSettings.alarm.mode.length) {
    deviceSettings.alarm.mode = alarmAllModeValue
    deviceSettings.alarm.display = '每天'
    updateDeviceAlarmConfig()
  }
}

function onToggleAlarmModeSelector (e) {
  console.log('onToggleAlarmModeSelector', e)
  alarmModeSelectorVisible.value = true
  overStyle.left = `${e.clientX - 218 + 123}px`
  overStyle.top = `${e.clientY - 194 - 123}px`
}

function onToggleLcdModeSelector (e) {
  console.log('onToggleLcdModeSelector', e)
  lcdModeSelectorVisible.value = true
  overStyle.left = `${e.clientX - 218 + 123}px`
  overStyle.top = `${e.clientY - 194}px`
}

function onToggleFanModeSelector (e) {
  console.log('onToggleFanModeSelector', e)
  fanModeSelectorVisible.value = true
  overStyle.left = `${e.clientX - 218}px`
  overStyle.top = `${e.clientY - 165}px`
}

const getDeviceConfig =  debounce(() => {
  getXOSDeviceStatus()
    .then(res => {
      console.log('getXOSDeviceStatus', res)
      const {set_config:config, hardware_ver: hardwareVer} = res || {}
      if (config) {
        // 是否展示该配置项
        deviceSettingsVisible.auto_power = !!config.auto_power
        deviceSettingsVisible.alarm = hardwareVer >= 1.5 && !!config.alarm
        deviceSettingsVisible.led = !!config.led
        deviceSettingsVisible.lcd = !!config.lcd
        deviceSettingsVisible.fan = !!config.fan
        // 初始化配置项的值
        deviceSettings.auto_power = config.auto_power?.enable === 1
        deviceSettings.alarm.enable = config.alarm?.enable === 1
        deviceSettings.led = config.led?.enable === 1
        deviceSettings.lcd = config.lcd?.ext?.mode
        deviceSettings.fan = config.fan?.ext?.mode
        if (typeof config.alarm?.ext === 'object') {
          const {off_time: offTime, on_time: onTime, repeat = alarmAllModeValue} = config.alarm.ext
          const offTimeArray = offTime.split(':')
          const onTimeArray = onTime.split(':')
          const repeatArray = repeat.split(',')
          deviceSettings.alarm.mode = repeat
          deviceSettings.alarm.display = repeat === alarmAllModeValue ? '每天': repeatArray.map(item => alarmModeDisplayArray[+item - 1]).join('/')
          deviceSettings.alarm.offTimeH = offTimeArray[0]
          deviceSettings.alarm.offTimeM = offTimeArray[1]
          deviceSettings.alarm.onTimeH = onTimeArray[0]
          deviceSettings.alarm.onTimeM = onTimeArray[1]
        }
        if (isLoading.value) isLoading.value = false
      }
    }).catch(toast)
}, 500)

watch(()=> props.isActive, (isActive) => {
  if (isActive) getDeviceConfig()
})

onMounted(getDeviceConfig)


return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Loading)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_unref(deviceSettingsVisible).auto_power || _unref(deviceSettingsVisible).alarm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_unref(deviceSettingsVisible).auto_power)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", {
                        class: "setting-switchbox",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOnToggleSetting('auto_power')))
                      }, [
                        _createVNode(Switch, {
                          value: _unref(deviceSettings).auto_power
                        }, null, 8, ["value"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(deviceSettingsVisible).alarm)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["setting-box autopower-setting", {'border-radius-top': _unref(deviceSettings).alarm}])
                    }, [
                      _hoisted_8,
                      _createElementVNode("div", {
                        class: "setting-switchbox",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleOnToggleSetting('alarm')))
                      }, [
                        _createVNode(Switch, {
                          value: _unref(deviceSettings).alarm.enable
                        }, null, 8, ["value"])
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (_unref(deviceSettingsVisible).alarm && _unref(deviceSettings).alarm.enable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          max: "24",
                          min: "0",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(deviceSettings).alarm.onTimeH) = $event)),
                          onInput: _cache[3] || (_cache[3] = (e) => handleOnInputAlarmTime(e, 'onTimeH', 23))
                        }, null, 544), [
                          [_vModelText, _unref(deviceSettings).alarm.onTimeH]
                        ]),
                        _hoisted_11,
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          max: "59",
                          min: "0",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(deviceSettings).alarm.onTimeM) = $event)),
                          onInput: _cache[5] || (_cache[5] = (e) => handleOnInputAlarmTime(e, 'onTimeM', 59))
                        }, null, 544), [
                          [_vModelText, _unref(deviceSettings).alarm.onTimeM]
                        ])
                      ]),
                      _hoisted_12,
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          max: "24",
                          min: "0",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(deviceSettings).alarm.offTimeH) = $event)),
                          onInput: _cache[7] || (_cache[7] = (e) => handleOnInputAlarmTime(e, 'offTimeH', 22))
                        }, null, 544), [
                          [_vModelText, _unref(deviceSettings).alarm.offTimeH]
                        ]),
                        _hoisted_13,
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          max: "59",
                          min: "0",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(deviceSettings).alarm.offTimeM) = $event)),
                          onInput: _cache[9] || (_cache[9] = (e) => handleOnInputAlarmTime(e, 'offTimeM', 59))
                        }, null, 544), [
                          [_vModelText, _unref(deviceSettings).alarm.offTimeM]
                        ])
                      ]),
                      _hoisted_14,
                      _createVNode(XPopover, {
                        visible: alarmModeSelectorVisible.value,
                        align: "bottom-right",
                        onClose: hideAlarmModeSelector,
                        "overlay-position": "fixed",
                        "overlay-style": _unref(overStyle)
                      }, {
                        reference: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "setting-selector alarm-selector",
                            onClick: onToggleAlarmModeSelector
                          }, [
                            _createElementVNode("label", {
                              title: _unref(deviceSettings).alarm.display
                            }, _toDisplayString(_unref(deviceSettings).alarm.display), 9, _hoisted_15),
                            _hoisted_16
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("ul", _hoisted_18, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(alarmModes, (mode) => {
                                return _createElementVNode("li", {
                                  key: mode.value,
                                  onClick: ($event: any) => (handleSetAlarmMode(mode.value)),
                                  checked: _unref(deviceSettings).alarm.mode === alarmAllModeValue || _unref(deviceSettings).alarm.mode.includes(mode.value)
                                }, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("label", null, _toDisplayString(mode.label), 1)
                                  ]),
                                  _hoisted_20
                                ], 8, _hoisted_19)
                              }), 64))
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["visible", "overlay-style"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(deviceSettingsVisible).led)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", {
                    class: "setting-switchbox",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (handleOnToggleSetting('led')))
                  }, [
                    _createVNode(Switch, {
                      value: _unref(deviceSettings).led
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(deviceSettingsVisible).lcd)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(XPopover, {
                    visible: lcdModeSelectorVisible.value,
                    align: "bottom-right",
                    onClose: _cache[11] || (_cache[11] = ($event: any) => (lcdModeSelectorVisible.value = false)),
                    "overlay-position": "fixed",
                    "overlay-style": _unref(overStyle)
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "setting-selector",
                        onClick: onToggleLcdModeSelector
                      }, [
                        _createElementVNode("label", null, _toDisplayString(lcdModesValue2LabelMaps[_unref(deviceSettings).lcd]), 1),
                        _hoisted_31
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("ul", _hoisted_33, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(lcdModes, (mode) => {
                            return _createElementVNode("li", {
                              key: mode.value,
                              onClick: ($event: any) => (handleSetLcdMode(mode.value)),
                              checked: _unref(deviceSettings).lcd === mode.value
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", null, _toDisplayString(mode.label), 1)
                              ]),
                              _hoisted_35
                            ], 8, _hoisted_34)
                          }), 64))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible", "overlay-style"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(deviceSettingsVisible).fan)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(XPopover, {
                    visible: fanModeSelectorVisible.value,
                    align: "bottom-right",
                    onClose: _cache[12] || (_cache[12] = ($event: any) => (fanModeSelectorVisible.value = false)),
                    "overlay-position": "fixed",
                    "overlay-style": _unref(overStyle)
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "setting-selector",
                        onClick: onToggleFanModeSelector
                      }, [
                        _createElementVNode("label", null, _toDisplayString(fanModes[_unref(deviceSettings).fan - 1].label), 1),
                        _hoisted_41
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("ul", _hoisted_43, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fanModes, (mode) => {
                            return _createElementVNode("li", {
                              key: mode.value,
                              onClick: ($event: any) => (handleSetFanMode(mode.value)),
                              checked: _unref(deviceSettings).fan === mode.value
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", null, _toDisplayString(mode.label), 1),
                                _createElementVNode("p", null, _toDisplayString(mode.text), 1)
                              ]),
                              _hoisted_45
                            ], 8, _hoisted_44)
                          }), 64))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible", "overlay-style"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})